import React, { useContext } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { ThemeContext } from 'providers/ThemeProvider';
import { Container, Button } from 'components/common';
import skills from 'assets/illustrations/skills.svg';
import { Wrapper, SkillsWrapper, Details, Detail, Thumbnail } from './styles';

export const Skills = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <Wrapper id="about">
      <SkillsWrapper as={Container}>
        <Thumbnail>
          <img src={skills} alt="I’m Ankit and I’m a Frontend engineer and a freelancer!" />
        </Thumbnail>
        <Details theme={theme}>
          <h1>More about me</h1>
          <p>
            <div>👨🏻‍💻 Web3 veteran at Polygon, building the future with JavaScript.</div>
            <div>🪄 Crafting innovative dApps with JavaScript expertise.</div>
            <div>👷🏻‍♂️ Full-stack developer, comfortable on both frontend and backend.</div>
            <div>☕️ Tea-loving swimmer, recharging outside the code.</div>
            <div>👀 Passionate about the potential of web3!</div>
          </p>
          <Button as={AnchorLink} href="#contact">
            Hire me
          </Button>
        </Details>
      </SkillsWrapper>
    </Wrapper>
  );
};
